const initState = {
  loading: false,
  deleteLoading: false,
  addLoading: false,
  editLoading: false,
  responseLoading: false,
  question: [],
  responses: [],
  fetchLoading: false,
};
const checkoutQuestionReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_QUESTION":
      return {
        ...state,
        question: action.payload,
      };
    case "FETCH_QUESTION":
      return {
        ...state,
        fetchLoading: action.payload,
      };
    case "GET_RESPONSES":
      return {
        ...state,
        responses: action.payload,
      };
    case "RESPONSE_LOADER": 
      return {
        ...state,
        responseLoading: action.payload, 
      };
    case "QUESTION_LOADER":
      return {
        ...state,
        loading: action.payload,
      };
    case "ADD_LOADER":
      return {
        ...state,
        addLoading: action.payload,
      };
    case "DELETE_LOADER":
      return {
        ...state,
        deleteLoading: action.payload,
      };
    case "EDIT_LOADER":
      return {
        ...state,
        editLoading: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};
export default checkoutQuestionReducer;
